

























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  evaluatePemeriksaanReadOnly,
  isDischargeLock
} from "@/utility/PemeriksaanReadonly";
import type {
  ActiveApproval,
  ReadOnlyResult,
  VerifikasiLockResult
} from "@/utility/PemeriksaanReadonly";
import AjukanAksesRevisiDialog from "@/components/pemeriksaan/AjukanAksesRevisiDialog.vue";
import revisionAccessModule from "@/store/modules/RevisionAccessStore";

interface RegisterLike {
  dout?: string | null;
  hout?: string | number | null;
  discharge_at?: string | null;
  no?: string | null;
}

@Component({
  components: { AjukanAksesRevisiDialog }
})
export default class PemeriksaanReadonlyBanner extends Vue {
  @Prop({ required: true }) register!: RegisterLike | null;

  @Prop({ default: null }) registerNo!: string | null;
  @Prop({ default: null }) result!: ReadOnlyResult | null;
  @Prop({ default: null }) verifikasiResult!: VerifikasiLockResult | null;

  keteranganPengajuanVerifikasi =
    "Pasien sudah pulang. Verifikasi rekam medis (CPPT, Read Back, Hand " +
    "Over, CPO, Rekonsiliasi Obat, Asesmen Keperawatan, dst.) hanya dapat " +
    "dilakukan setelah pengajuan ini disetujui Tim Rekam Medis atau Super Admin.";

  get effectiveRegisterNo(): string | null {
    return this.registerNo || this.register?.no || null;
  }

  get activeApproval(): ActiveApproval | null {
    if (!this.effectiveRegisterNo) return null;
    const snap = revisionAccessModule.activeByRegister[this.effectiveRegisterNo];
    if (!snap || !snap.has_active || !snap.active) return null;
    return {
      expiresAt: snap.active.expires_at,
      approvedAt: snap.active.approved_at,
      grantedMinutes: snap.active.granted_minutes
    };
  }

  get effectiveResult(): ReadOnlyResult {
    if (this.result) return this.result;

    return evaluatePemeriksaanReadOnly(
      this.register,
      new Date(),
      this.activeApproval
    );
  }

  get verifikasiTerkunci(): boolean {
    return !!this.verifikasiResult?.locked;
  }

  get aksesRevisiAktif(): boolean {
    return (
      this.effectiveResult.reason === "editable_with_approval" ||
      this.verifikasiResult?.reason === "dibuka_approval"
    );
  }

  get masaKoreksi(): boolean {
    return this.effectiveResult.reason === "editable_grace";
  }

  get pesanAksesRevisiAktif(): string {
    if (this.effectiveResult.reason === "editable_with_approval") {
      return this.effectiveResult.message;
    }
    return this.verifikasiResult?.message || "";
  }

  get isUnitLain(): boolean {
    return this.effectiveResult.reason === "unit_lain_non_dokter";
  }

  get bolehAjukanRevisi(): boolean {
    const b = this.effectiveResult.blockers || [];

    return b.some(isDischargeLock) && !b.includes("unit_lain_non_dokter");
  }

  @Watch("effectiveRegisterNo", { immediate: true })
  onRegisterChange(no: string | null) {
    if (!no) return;
    const baseResult = evaluatePemeriksaanReadOnly(this.register);
    if (baseResult.dischargeAt) {
      revisionAccessModule.fetchActive(no);
    }
  }
}
